export const useTheme = () => {
  const theme = useState<string>('theme', () => 'light')

  const switchTheme = (newTheme: 'light' | 'dark') => {
    theme.value = newTheme
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
  }
  onMounted(() => {
    const savedTheme = localStorage.getItem('theme') || 'light'
    switchTheme(savedTheme as 'light' | 'dark')
  })
  return { theme, switchTheme }
}